import {
  makeAddressArraySync,
  makeAddressSync,
  ProtocolConfig,
} from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";
import { MARKET_ADDRESS } from "../market-address";


export const lrtbase = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "cbBTC",
  secondBridgeSymbol: null,
  marketWhitelist: new Set([
    MARKET_ADDRESS.lrtbase.solvBTC,
    MARKET_ADDRESS.lrtbase.solvBTCBNN,
    MARKET_ADDRESS.lrtbase.LBTC,
    MARKET_ADDRESS.lrtbase.PT_LBTC,
  ]),
  pinnedMarkets: [],
  markets: {
    [MARKET_ADDRESS.lrtbase.PT_LBTC]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
  },
  nativeRewards: {
    siloIncentivesControllerAddress: makeAddressSync(
      "0x5825E982Dec576B6e7743be493fd8807A610860B"
    ),
    tokenAddress: TOKEN_ADDRESS.base.SILO,
    symbol: "SILO",
    decimals: 18,
    historicalShareTokens: {
      [TOKEN_ADDRESS.base.SILO]: makeAddressArraySync([
        // sSolvBTC
        "0x0ea1FC0E5fd433839cc754e2193cab3d4e22E62A",
        // scbBTC-SolvBTC
        "0xcbDbfA51446903bF71Ea6Aba04071DB2385939b5",
        // sSolvBTC.BBN
        "0xA4dD6e82e22e5467BBD8A0558C1BF88627e68Eb4",
        // scbBTC-SolvBTC.BBN
        "0xB67DB1EED24671c2BD7e2A929376b42aace8c9d3",
        //sLBTC
        "0x2be0FfcF9341efaC634443055A3A1B081E5b6DE8",
        //scbBTC-LBTC
        "0xb1f78d0fAc2DbDa0C3bc5F6A441c683FC46500e5",
        //spPT-LBTC
        "0x2F6725128086575Bcdb54Cf7171cf5b8b85C7e78",
        //scbETH-PT-LBTC
        "0x92F4266b8B0140Cd550CE6A7F0483339CD7aCd55",
      ]),
    },
  },
} as const);
